import React from 'react';

export type DatetimeButtonGroupProps = {
  handleClick: F<string>;
  aggName: string;
  options: string[];
};

export const DatetimeButtonGroup: React.FC<DatetimeButtonGroupProps> = ({
  handleClick,
  aggName,
  options,
}) => {
  const changeSelection = (aggType: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    handleClick(aggType);
  };

  return (
    <div className="btn-group" role="group">
      <button
        type="button"
        className="btn btn-outline-dark dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {aggName}
        <span className="caret" />
      </button>
      <ul className="dropdown-menu">
        {options.map((option) => (
          <li key={option} onClick={changeSelection(option)}>
            <a className="dropdown-item" href="#">
              {option}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DatetimeButtonGroup;
